import React, { useEffect, useState, useRef } from 'react'
import { Dropdown } from 'semantic-ui-react'
import styles from './dateDropdown.m.scss'

export const DateDropdown = ({ value, onChange, options }) => {
  const [valueChanged, setValueChanged] = useState(false)
  const timeout = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    setValueChanged(true)

    timeout.current = setTimeout(() => {
      setValueChanged(false)
    }, 1400)
  }, [value])

  useEffect(() => {
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current)
      }
    }
  }, [])

  return (
    <div
      className={`${styles.dateDropdownContainer} ${
        valueChanged ? styles.newValue : ''
      }`}
    >
      <Dropdown
        upward={false}
        value={value}
        onChange={onChange}
        options={options}
      />
    </div>
  )
}
